import { Box, BoxProps, Stack, Divider } from "@mui/material"

import { Loading } from 'components/controls/loading'
import { ErrorBlock } from 'components/controls/errorInfo'

import { ResearchProjectResult } from "interface/research"

import { SisetuPreviewDialog } from 'features/sisetu/dialog/preview'
import { KojinPreviewDialog } from 'features/kojin/dialog/preview'

import { useResearchPreview } from './container'
import { ResearchPreviewHeader } from './components/header'
import { ResearchPreviewBody } from './components/body'
import { ResearchPreviewFooter } from './components/footer'

type ResearchPreviewProps = {
  projectList?: ResearchProjectResult[]
  projectKey?: string | null
	project?: ResearchProjectResult | null
  targetSisetuCode?: string
  targetKojinCode?: string
	onSisetuOpenReply?: (sisetuCode: string | null) => void
  onKojinOpenReply?: (kojinCode: string | null) => void
  onClose?: () => void
} & BoxProps
export const ResearchPreview = ({
  projectList,
  projectKey: defaultProjectKey,
  project: defaultProject,
  targetSisetuCode,
  targetKojinCode,
  onSisetuOpenReply,
  onKojinOpenReply,
  onClose,
  ...others
}: ResearchPreviewProps) => {
  const container = useResearchPreview({
    projectList,
    defaultProject,
    defaultProjectKey,
    targetSisetuCode,
    targetKojinCode,
    onSisetuOpenReply,
    onKojinOpenReply,
    onClose
  })
  const {
    loading, error, project,
    /*onSisetuOpen,*/ selectedSisetuCode, sisetuList,
    /*onKojinOpen,*/ selectedKojinCode, kojinList,
    closeModal
  } = container

  return (
    <>
      <Box {...others}>
        {loading && <Loading/>}
        <ErrorBlock error={error}/>

        {project && (
          <Stack direction="column" sx={{ height: '100%', boxSizing: 'border-box' }}>
            <ResearchPreviewHeader project={project} container={container}/>
            <Divider/>
            <ResearchPreviewBody project={project} container={container} flexGrow={1} boxSizing='border-box' overflow='auto'/>
            <Divider/>
            <ResearchPreviewFooter project={project} container={container}/>
          </Stack>
        )}
      </Box>

      {selectedSisetuCode ? (
        <SisetuPreviewDialog
          sisetuList={sisetuList}
          sisetuCode={selectedSisetuCode}
          onClose={closeModal}
        />
      ) : selectedKojinCode ? (
        <KojinPreviewDialog
          kojinList={kojinList}
          kojinCode={selectedKojinCode}
          onClose={closeModal}
        />
      ) : <></>}
    </>
  )
}
